import { takeLatest, put, call } from 'redux-saga/effects';
//  SagaReturnType is a type, so it comes in as one. Imported as a value it trips
//  import/named, which cannot see a type-only export — the older sagas in this folder
//  still carry that error; CI only lints files a PR touches, so it goes unreported.
import type { SagaReturnType } from 'redux-saga/effects';
import { documentBundleActions } from 'src/redux/actions/constant';
import documentBundleService from 'src/services/apiServices/document-bundle/document-bundle-service';

const {
  REQUEST_SEARCH_PATIENTS,
  SUCCESS_SEARCH_PATIENTS,
  FAILURE_SEARCH_PATIENTS,
  LOADING_SEARCH_PATIENTS,
} = documentBundleActions;

function* searchPatients(action: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_SEARCH_PATIENTS });
    const response = yield call(documentBundleService.searchPatients, action.payload);
    if (response?.status === 200) {
      yield put({ type: SUCCESS_SEARCH_PATIENTS, payload: response.data?.data });
    } else {
      throw response?.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_SEARCH_PATIENTS, payload: error });
  }
}

// takeLatest, not takeEvery: the user types, and only the last term's results matter.
function* searchPatientsSaga() {
  yield takeLatest(REQUEST_SEARCH_PATIENTS, searchPatients);
}

export default searchPatientsSaga;
export { searchPatients };
